module.exports = __webpack_public_path__ + "4623d5ed1cb95f1048cb159bb584cbeb.png";